import React from 'react'
import MListItem from '../../atom/mListItem';
import MListItemIcon from '../../atom/mListItemIcon';
import MListItemText from '../../atom/mListItemText';

export default function IconLabelItem(props) {
    const { icon: Icon, label, iconClass, listItemClass } = props;
    return (
        <MListItem button key={label} className={listItemClass}>
            <MListItemIcon>
                <Icon className={iconClass} />
            </MListItemIcon>
            <MListItemText>{label}</MListItemText>
        </MListItem>
    )
}
